export const BEDROCK_ANTHROPIC_PROVIDER_PREFIX = "bedrock-anthropic";

export const BEDROCK_ANTHROPIC_FABLE_5_MODEL_ID = "anthropic.claude-fable-5";
export const BEDROCK_ANTHROPIC_FABLE_5_MODEL_REF =
  "bedrock-anthropic/anthropic.claude-fable-5";

export const BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_ID =
  "anthropic.claude-fable-5-1";
export const BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_REF =
  "bedrock-anthropic/anthropic.claude-fable-5-1";

export type BedrockAnthropicModelId =
  | typeof BEDROCK_ANTHROPIC_FABLE_5_MODEL_ID
  | typeof BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_ID;

export type BedrockAnthropicModelRef =
  | typeof BEDROCK_ANTHROPIC_FABLE_5_MODEL_REF
  | typeof BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_REF;

export function isBedrockAnthropicModelRef(
  modelRef: string | null | undefined,
): modelRef is BedrockAnthropicModelRef {
  return (
    modelRef === BEDROCK_ANTHROPIC_FABLE_5_MODEL_REF ||
    modelRef === BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_REF
  );
}

export function isBedrockAnthropicFable51ModelRef(
  modelRef: string | null | undefined,
): modelRef is typeof BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_REF {
  return modelRef === BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_REF;
}

/**
 * Logical Bedrock Anthropic Messages route model **id** (not ref) for either
 * Fable generation. The wire request carries the matching global inference
 * profile id; this logical id is what ARTI persists and keys pricing on.
 * Ids never key the ref-keyed capability tables — keep the distinction.
 */
export function isBedrockAnthropicFableModelId(
  modelId: string | null | undefined,
): modelId is BedrockAnthropicModelId {
  return (
    modelId === BEDROCK_ANTHROPIC_FABLE_5_MODEL_ID ||
    modelId === BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_ID
  );
}

/** Logical Bedrock Anthropic Messages route model **id** for Fable 5.1 only. */
export function isBedrockAnthropicFable51ModelId(
  modelId: string | null | undefined,
): modelId is typeof BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_ID {
  return modelId === BEDROCK_ANTHROPIC_FABLE_5_1_MODEL_ID;
}
